import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchUserInfo } from '../utils/services/fetchUser'
import { fetchDatabase } from '../utils/services/fetchDatabase'
import { useQuery } from '@tanstack/react-query'
import styled from 'styled-components'
import ChatSummary from '../components/Chat/ChatSummary'
import ChatDetails from '../components/Chat/ChatDetails'
import Sidebar from '../components/shared/Sidebar'

const StyledChat = styled.div`
    display: flex;
`
const StyledChatSummary = styled(ChatSummary)``
const StyledChatDetails = styled(ChatDetails)``

const Chat = () => {
    const location = useLocation()
    const { conversationId } = location.state || {}
    const [activeConversation, setActiveConversation] = useState(null)
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)

    // Get user info
    const {
        data: userInfo,
        isLoading: isLoadingUserInfo,
        isError: isErrorUserInfo,
    } = useQuery({
        queryKey: ['userInfo'],
        queryFn: fetchUserInfo,
        staleTime: 5 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching user info:', err)
        },
    })

    // get the database of the stuff categories
    const { data: stuffCategories } = useQuery({
        queryKey: ['categoryDatabase'],
        queryFn: fetchDatabase,
        staleTime: 60 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching stuff categories:', err)
        },
    })

    if (isLoadingUserInfo) {
        return <p>Chargement des conversations...</p>
    }

    if (isErrorUserInfo) {
        return <p>Erreur lors du chargement des conversations</p>
    }

    return (
        <StyledChat>
            {userInfo && (
                <Sidebar
                    setIsSidebarOpen={setIsSidebarOpen}
                    isSidebarOpen={isSidebarOpen}
                    userInfo={userInfo}
                />
            )}
            <StyledChatSummary
                userInfo={userInfo}
                setActiveConversation={setActiveConversation}
                conversationId={conversationId}
            />
            <StyledChatDetails
                userInfo={userInfo}
                activeConversation={activeConversation}
                stuffCategories={stuffCategories}
            />
        </StyledChat>
    )
}

export default Chat
